import React, { ReactNode } from 'react';
import styles from './formgroup.module.scss';
import FormGroupTooltip from 'features/shared/forms/components/formGroup/FormGroupTooltip';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import tooltipStyles from "features/shared/components/tooltip/tooltip.module.scss";

interface Props {
  children: ReactNode;
  validationError?: string;
  labelText?: string;
  inputId?: string;
  visible?: boolean;
  className?: string;
  tooltip?: FormGroupTooltip;
}

const FormGroup = ({ children, validationError, labelText, inputId, visible = true, className, tooltip }: Props) => {
  // helpers
  const getErrorClass = () => {
    return validationError ? ` ${styles.error}` : "";
  }
  
  // sub-renders
  const renderError = () => {
    if (validationError) {
      return (
        <div className="invalid-feedback d-block">{validationError}</div>
      );
    }
  }
  
  const renderLabel = () => {
    if (labelText) {
      return (
        <label htmlFor={inputId} className="text-muted mb-0">
          <span>{labelText}</span>
        </label>
      );
    }
  }
  
  const rednerTooltip = () => { 
    if (tooltip) {
      return (
        <OverlayTrigger
          placement={tooltip.placement ?? "auto"}
          overlay={
            <Tooltip id={tooltip.id} className={tooltipStyles.tooltip}>
              {renderTooltipContent(tooltip)}
            </Tooltip>
          }
          trigger={tooltip.trigger}
          rootClose={tooltip.trigger === "click"}
        >
          <span className={tooltip.alignIconToRight ? "ml-auto" : "ml-2"}>
            {renderTooltipOpen(tooltip)}
          </span>
        </OverlayTrigger>
      );
    }
  }

  const renderTooltipOpen = (tooltip: FormGroupTooltip) => { 
    if (tooltip.text) {
      return tooltip.text();
    } else {
      return (
        <FontAwesomeIcon 
            icon={tooltip.icon ?? ["far", "question-circle"]} 
            className="text-muted" 
          />
      );
    }
  }

   const renderTooltipContent = (tooltip: FormGroupTooltip) => { 
     if (typeof tooltip.content === "string") {
       return (
        <div
          dangerouslySetInnerHTML={{ __html: tooltip.content }}
        />
       )
     } else {
       return tooltip.content
     }
  }

  const renderLabelTooltipItem = () => { 
    if (labelText || tooltip) {
      return (
        <div className="d-flex align-items-center mb-2">
          {renderLabel()}
          {rednerTooltip()}
        </div>
      );
    }
  }

  // render
  if (visible) {
    return (
      <div className={`form-group${getErrorClass()}${className ? ` ${className}` : ""}`}>
        {renderLabelTooltipItem()}
        {children}
        {renderError()}
      </div>
    )   
  } else {
    return null;
  }
}

export default FormGroup;
